import sieviApi from "@/api/sieviApi"
// export const myAction = async ( { commit } ) => {

// }

export const obtainCampusAdministrador = async ( { commit } ) => {
    try {
        await sieviApi.get('/sanctum/csrf-cookie')
        const { data } = await sieviApi.get(`/api/administrador/campus`)
        if (data.ok) {
            commit('setCampus', data.campus)
            return { ok: true, message: data.message }
        } else {
            return { ok: false, message: data.message }
        }

    } catch (error) {
        return { ok: false, message: error/* .response.data.error.message */ }
    }
}

export const createCampus = async ( _, { form } ) => {
    const campusForm = {
        nombre: form.name,
    }
    try {
        await sieviApi.get('/sanctum/csrf-cookie')
        const { data } = await sieviApi.post(`/api/administrador/campus`, campusForm)
        if (data.ok) {
            return { ok: true, message: data.message }
        } else {
            return { ok: false, message: data.message }
        }
    } catch (error) {
        return { ok: false, message: error }
    }
} 

export const editCampus = async ( _, { form } ) => {
    const campusForm = {
        nombre: form.name
    }
    try {
        await sieviApi.get('/sanctum/csrf-cookie')
        const { data } = await sieviApi.put(`/api/administrador/campus/${form.id}`, campusForm)
        if (data.ok) {
            return { ok: true, message: data.message }
        } else {
            return { ok: false, message: data.message }
        }
    } catch (error) {
        return { ok: false, message: error }
    }
}

export const deleteCampus = async ( _, idCampus ) => {
    try {
        await sieviApi.get('/sanctum/csrf-cookie')
        const { data } = await sieviApi.delete(`/api/administrador/campus/${idCampus}`)
        if (data.ok) {
            return { ok: true, message: data.message }
        } else {
            return { ok: false, message: data.message }
        }
    } catch (error) {
        return { ok: false, message: error }
    }
}

export const obtainCampusAuditor = async ( { commit } ) => {
    try {
        await sieviApi.get('/sanctum/csrf-cookie')
        const { data } = await sieviApi.get(`/api/auditor/campus`)
        if (data.ok) {
            commit('setCampus', data.campus)
            return { ok: true, message: data.message }
        } else {
            return { ok: false, message: data.message }
        }

    } catch (error) {
        return { ok: false, message: error/* .response.data.error.message */ }
    }
}

export const obtainCampusTeacher = async ( { commit }, id ) => {
    try {
        await sieviApi.get('/sanctum/csrf-cookie')
        const { data } = await sieviApi.get(`/api/administrador/usuarios/campus/${id}`)
        if (data.ok) {
            commit('setCampusTeacher', data.campus)
            return { ok: true, message: data.message }
        } else {
            return { ok: false, message: data.message }
        }

    } catch (error) {
        return { ok: false, message: error/* .response.data.error.message */ }
    }
}

export const obtainCampusResponsible = async ( { commit }, id ) => {
    try {
        await sieviApi.get('/sanctum/csrf-cookie')
        const { data } = await sieviApi.get(`/api/responsable/campus/${id}`)
        if (data.ok) {
            commit('setCampus', data.campus)
            return { ok: true, message: data.message }
        } else {
            return { ok: false, message: data.message }
        }

    } catch (error) {
        return { ok: false, message: error/* .response.data.error.message */ }
    }
}